import {Button as PrimeButton} from "primereact/button";
import styled from "styled-components";

export const Button = styled(PrimeButton)`
    border-radius: 6px;
    background-color: ${({theme}) => theme.color_action};
    border: none;
`;
